import { createBrowserRouter } from 'react-router-dom';
import Home from './pages/Home';
import Login from './pages/Login';
import MyMemorials from './pages/MyMemorials';
import CreateMemorial from './pages/CreateMemorial';
import Memorial from './pages/Memorial';
import MemorialEdit from './pages/MemorialEdit';
import Article from './pages/Article';
import SeoArticles from './pages/SeoArticles';
import Settings from './pages/Settings';
import ForgotPassword from './pages/ForgotPassword';
import MockPay from './pages/MockPay';
import Heroes from './pages/Heroes';
import Leaderboard from './pages/Leaderboard';
import Admin from './pages/admin/Admin';

export const router = createBrowserRouter([
  { path: '/', element: <Home /> },
  { path: '/login', element: <Login /> },
  { path: '/heroes', element: <Heroes /> },
  { path: '/leaderboard', element: <Leaderboard /> },
  { path: '/admin', element: <Admin /> },
  { path: '/settings', element: <Settings /> },
  { path: '/forgot-password', element: <ForgotPassword /> },
  { path: '/memorials', element: <MyMemorials /> },
  { path: '/create', element: <CreateMemorial /> },
  { path: '/m/:slug', element: <Memorial /> },
  { path: '/m/:slug/edit', element: <MemorialEdit /> },
  { path: '/m/:slug/articles/:articleId', element: <Article /> },
  { path: '/articles', element: <SeoArticles /> },
  { path: '/articles/:slug', element: <SeoArticles /> },
  { path: '/__mock-pay/:orderId', element: <MockPay /> },
  { path: '*', element: <Home /> },
]);
